var render = function render(_c,_vm){return _c('i',{class:{
    'el-icon-check':
      _vm.props.row[_vm.props.column] === 1 || _vm.props.row[_vm.props.column] === true,
    'el-icon-close':
      _vm.props.row[_vm.props.column] === 0 || _vm.props.row[_vm.props.column] === false
  },style:({ color: _vm.props.row[_vm.props.column] === true ? 'green' : 'red' })})
}
var staticRenderFns = []

export { render, staticRenderFns }